import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { environment } from '../environments/environment';
import { IAppConfig } from '../models/app-config.model';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AppConfig {

    static settings: IAppConfig;

    constructor(private http: Http) { }

    load() {
        const jsonFile = `assets/config/config.${environment.name}.json?t=${(new Date()).getTime()}`;
        return new Promise<void>((resolve, reject) => {
            this.http.get(jsonFile).toPromise().then((response: Response) => {
                AppConfig.settings = <IAppConfig>response.json();
                resolve();
            }).catch((response: any) => {
                reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/app.config.ts